module.exports = __webpack_public_path__ + "img/infection-enter.02ffffa3.png";